module.exports = __webpack_public_path__ + "static-m/img/z2.74ede492.jpg";